import { render, staticRenderFns } from "./CustomerOrdersCreate.vue?vue&type=template&id=7b30fbc0&scoped=true"
import script from "./CustomerOrdersCreate.vue?vue&type=script&lang=js"
export * from "./CustomerOrdersCreate.vue?vue&type=script&lang=js"
import style0 from "./CustomerOrdersCreate.vue?vue&type=style&index=0&id=7b30fbc0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b30fbc0",
  null
  
)

export default component.exports